<template>
  <div class="portfolio-area pb--120 pt--20">
    <v-container>
      <v-row>
        <!-- Start Single Portfolio  -->
        <v-col
            lg="4"
            md="4"
            sm="6"
            cols="12"
            class="mt--40"
            v-for="(item, i) in (items || gardensContent)"
            :key="i">
          <div class="im_portfolio text-center">
            <div class="thumbnail_inner">
              <div class="thumbnail">
                <a :href="items ? item.url : getUrl(item.url)">
                  <img class="w-100" :src="item.src" :alt="item.title || ''" width="595" height="595" style="height: auto" />
                </a>
              </div>
            </div>
            <div class="content">
              <div class="inner">
              </div>
            </div>
            <a class="transparent_link" :href="items ? item.url : getUrl(item.url)" :aria-label="item.title || undefined"></a>
          </div>
        </v-col>
        <!-- End Single Portfolio  -->
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {getLandingPageSettings} from "@/scripts/settings";

export default {
  props: {items: {type: Array, default: null}},
  components: {
  },
  data() {
    return {
      gardensContent: null
    };
  },
  mounted() {
    if (!this.items) this.fetchSettings();
  },
  methods: {
    getUrl(url){
      if(this.$route.params.lang){
        return "/" + this.$route.params.lang + url;
        return s;
      }
      return "/en"+url;
    },
    fetchSettings(){
      let landigpageName = "corporate";
      getLandingPageSettings(landigpageName).then((settings) => {
        this.gardensContent = settings.gardensContent;
      });
    },
  },
};
</script>
